import { render, staticRenderFns } from "./kategoriPenilaian.vue?vue&type=template&id=373b5bdf"
import script from "./kategoriPenilaian.vue?vue&type=script&lang=js"
export * from "./kategoriPenilaian.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports